<template>
<footer>
    <div class="mdown_wrap">
        <a v-if="contents.currentSlide != null && contents.currentSlide.hasOwnProperty('tutor')" href="#" class="mdownbt popupbt" @click="showTutorModal()">강사소개</a>
        <a v-if="contents.currentSlide != null && contents.currentSlide.hasOwnProperty('download')"
            @click="downloadHandler()" href="#" class="mdownbt">다운로드</a>
    </div>
    <div class="sidenav" v-if="contents.currentSlide != null && contents.currentSlide.type != 'quiz'">
        <a v-if="contents.slideNumber > 1"
            @click.prevent="previousPage(1)" href="#" class="sidepre">
            
            <i class="fas fa-caret-left"></i>
        </a>
        <a v-if="contents.slideNumber < contents.currentSlideCount" 
            @click.prevent="nextPage(1)"
            href="#" class="sidenext">
            <i class="fas fa-caret-right"></i>
        </a>
    </div>
    <div class="footer claerfix">
        <div class="downbt_wrap float_left">
            <a @click.prevent="goPreviousChapter(1)" href="#" v-if="previousChapter" class="downbt">이전 차시</a>
            <a @click.prevent="goNextChapter(1)" href="#" v-if="nextChapter" class="downbt">다음 차시</a>
            <a v-if="contents.currentSlide != null && contents.currentSlide.hasOwnProperty('tutor')"
				href="#" class="downbt" @click="showTutorModal()">강사소개</a>
            <a v-if="contents.currentSlide != null && contents.currentSlide.hasOwnProperty('download')"
			@click="downloadHandler()" href="#" class="downbt">다운로드</a>
        </div>
        <div class="footer_pager float_right">
            <a v-if="contents.slideNumber > 1"
                @click.prevent="previousPage(1)"  href="#" class="arrowbt"><i class="fas fa-angle-left"></i></a>
            <div class="pagenum">
                <span class="num">{{getCurrentPage()}}</span>
                <span class="pagespot">/</span>
                <span class="num">{{getTotalPage()}}</span>
            </div>
            <a v-if="contents.slideNumber < contents.currentSlideCount" 
                @click.prevent="nextPage(1)" href="#" class="arrowbt"><i class="fas fa-angle-right"></i></a>
        </div>
    </div>
    <div v-if="contents.currentSlide != null && contents.currentSlide.hasOwnProperty('tutor')"
        class="lec_modal" v-show="isOpen">
        <div class="modal_wrap" >
            <img :src="'../assets/images/' + contents.currentSlide.tutor" alt="정도진 교수 소개">
            <button class="close_modal" @click="closeTutorModal()">닫기</button>
        </div>
    </div>
</footer>
</template>
<script>
import {pad} from '../helpers'
export default {
    props : ['contents'],
    data(){
        return{
            isOpen : false,
            list : []
        }
    },
    computed:{
        nextChapter(){
            if(typeof settings !== 'undefined' && settings.nextChapterBtn 
            && this.contents.slideNumber == this.contents.currentSlideCount
            && this.contents.chapterId < this.contents.chapterCount){
                return true;
            }
            return false;
        },
        previousChapter(){
            if(typeof settings !== 'undefined'  && settings.previousChapterBtn && this.contents.chapterId > 1 && this.contents.slideNumber == 1){
                return true;
            }
            return false;
        },
    },
    methods:{
        getCurrentPage(){
            return pad(this.contents.slideNumber);
        },
        getTotalPage(){
            return pad(this.contents.currentSlideCount);
        },
        showTutorModal(){
            this.isOpen = true
        },
        closeTutorModal(){
            this.isOpen = !this.isOpen
        },
        nextPage(value){
            if(typeof settings.nextPage !== 'undefined' && settings.nextPage != null){
                return  settings.nextPage(this.contents.slideNumber);
            }
            location.href =  "./" + pad(this.contents.slideNumber + value) + ".html";
		},
        previousPage(value){
            if(typeof settings.previousChapter !== 'undefined' && settings.previousPage != null ){
                return settings.previousPage(this.contents.slideNumber);
            }
            location.href =  "./" + pad(this.contents.slideNumber - value) + ".html";
		},
		downloadHandler(){
			window.open("./data/" + this.contents.currentSlide.download);
        },
        goNextChapter(value){
            if(typeof settings.nextChapter !== 'undefined' && settings.nextChapter != null ){
                return settings.nextChapter(this.contents.chapterId);
            }
            location.href =  `../${pad(this.contents.chapterId + 1)}/01.html`;
        },
        goPreviousChapter(value){
            if(typeof settings.previousChapterBtn !== 'undefined' && settings.previousChapter != null  ){
                return settings.previousChapter(this.contents.chapterId);
            }
            location.href =  `../${pad(this.contents.chapterId - 1)}/01.html`;
        }
    },
    mounted(){
    }
}
</script>